
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import { routers } from '@/router/router'
    //import { getLodop, demoDownloadPDF } from '@/common/js/LodopFuncs'
    import { GetPrintWorld } from '@/common/js/PrintWorld'
    import UpdatebackabroadorderStatu from '@/store/entities/back-updatestatus'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list'

    import userList from '@/store/entities/userinfo'
    import UpdateOderStatu from './update-abroadorder-status.vue'
    import BaleStockOrder from './bale-abroadorder.vue'
    import moment from 'moment'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);
    import VueClipboard from 'vue-clipboard2'
    import { Select } from '../../../types/iview/select';
    Vue.use(VueClipboard)


    class PageOrderRequest extends PageRequest {
        orderStatus?: number;
        packageStatus?: number;
        SearchInfo: string;
        userCode: string;
        BeginTime?: Date;
        EndTime?: Date;
        storeId?: number;
        PlatformType: number;
        tradeNo: string;
        isTwoSales: boolean;
        returnNumber: string;
        packedBeginTime?: Date;
        packedEndTime?: Date;
        productorderStatu?: number;
        constructor() {
            super();
            //this.PlatformType = 0;
            this.orderStatus = null;
            this.packageStatus = null;
        }
    }

    @Component({
        name: "backabroadorder",
        components: { BaleStockOrder, UpdateOderStatu }

    })
    export default class Orders extends AbpBase {
        pagerequest: PageOrderRequest = new PageOrderRequest();
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        receivedTime: Date[] = [];
        selectuser: userList = new userList();
        orderStatus = Enums.getEnum(Enums.WarehouseOrderStatus, true);
        PlatformType = Enums.getEnum(Enums.PlatformType, true);
        packageStatus = Enums.getEnum(Enums.WarehouseOrderPackageStatus, true);
        urgentStatus = Enums.getEnum(Enums.WhetherHandleStatus, true);
        productorderList = Enums.getEnum(Enums.ProductOrderStatus, true);
        packedTime: Date[] = [];
        updateOderStatuShow = false;
        editModalShow: boolean = false;
        storeaddressList: Array<storeaddressInfo> = [];
        automaticJump: boolean = true;
        isLoadPrintList: boolean = false;
        flag: boolean = false;
        isShow: boolean;
        baleStockOrderModal: boolean = false;
        orderNumberList: string[] = [];
        logisticsList: string[] = [];
        BaseSkuNums: number[] = [];
        clickedButtons= {};
        automatic: boolean = false;
        automaticPack: boolean = false;
        needCert: boolean = false;
        user: Array<userList> = [];
        get list() {
            return this.$store.state.backabroadorder.list;
        };
        get loading() {
            return this.$store.state.backabroadorder.loading;
        }
        pageChange(page: number) {
            this.$store.commit('backabroadorder/setCurrentPage', page);
            this.getpage();
        }
        handleChangeImg($event) {
            if ($event.currentTarget.className == 'img') {
                $event.currentTarget.className = 'img open';
            } else {
                $event.currentTarget.className = 'img';
            }
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('backabroadorder/setPageSize', pagesize);
            this.getpage();
        }


        async exportexpress() {
            await this.$store.dispatch({
                type: 'backabroadorder/impotExcel',
                data: this.pagerequest
            })
        }

        @Watch('$route.params.inputShipment')
        inputShipmentChange() {
            var s = '';
            if (this.$route.params.inputShipment) {
                this.pagerequest = new PageOrderRequest();
                this.pagerequest.SearchInfo = this.$route.params.inputShipment;
                this.$store.state.backabroadorder.currentPage = 1;
                this.automatic = true;
                this.getpage();
            }

        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            if (this.storeaddressList.length == 1) {
                this.pagerequest.storeId = this.storeaddressList[0].id;
            }
            else {
                this.storeaddressList.push(a);
                this.pagerequest.storeId = null;
            }
            
        }

        async playAudio() {
            var Audio2: any = document.getElementById("Audio2");
            Audio2.play();
        }


        async Newpacked(data: any) {

            //var selectionData: any = this.$refs.selection;
            //var selection = selectionData.getSelection();
            //if (!selection || selection.length == 0) {
            //    this.$Message.error("选中项不能为空！");
            //    return;
            //}
            var ids = [];
            var abnormalOrderList: any[] = [];
            //for (var i = 0; i < selection.length; i++) {


            //}

            for (var j = 0; j < data.logistics.length; j++) {
                if (data.logistics[j].orderCount > 1) {
                    this.logisticsList.push(data.logistics[j].shipment);
                }
            }
            //if (selection[i].productOrderStatus != 2) {
            //    this.orderNumberList.push(selection[i].orderNumber);

            if (data.productOrderStatus !== null && data.productOrderStatus !== undefined) {
                var statuName = Enums.ProductOrderStatus.filter(function (item) { return item.value == data.productOrderStatus })[0].name;
                if (statuName != "待发货") {
                    this.orderNumberList.push(data.orderNumber);
                }
            }
            if (data.abnormalUserId) {
                abnormalOrderList.push({ orderNumber: data.orderNumber, abnormalUserId: data.abnormalUserId });
            }


            this.$store.state.backabroadorder.BaseSkuNums = data.orderProductInfoList.length;
            if (this.logisticsList.length > 0) {
                var _this = this;
                _this.$Modal.confirm({
                    title: "是否打包", content: "快递单号为【" + this.logisticsList + "】关联多个虾皮订单，是否继续标为已打包？", width: 800, onOk: async () => {
                        this.logisticsList = [];
                        setTimeout(() => {
                            _this.OrderNumberPrompt(data.id, abnormalOrderList);
                        }, 500);

                    }, onCancel: () => {
                        this.logisticsList = [];
                    }
                });
            }
            else {
                this.OrderNumberPrompt(data.id, abnormalOrderList);
            }
        }

        OrderNumberPrompt(id: number, abnormalOrderList: any[]) {
            var _this = this;
            if (_this.orderNumberList.length > 0) {
                _this.$Modal.confirm({
                    title: "是否打包", content: "订单编号为【" + _this.orderNumberList + "】,产品订单状态不为【待发货】状态，是否继续标为已打包？", width: 800, onOk: () => {
                        _this.orderNumberList = [];
                        _this.ShowPacked(id, abnormalOrderList);
                    }, onCancel: () => {
                        _this.orderNumberList = [];
                    }
                });
            }
            else {
                _this.ShowPacked(id, abnormalOrderList);
            }
        }


        async ShowPacked(id: number, abnormalOrderList: any[]) {
            this.$store.state.backabroadorder.id = id;

            this.$store.state.backabroadorder.abnormalOrderList = abnormalOrderList;
            this.$store.state.backabroadorder.automaticJump = this.automaticJump;
            this.baleStockOrderModal = true;
        }

        async cancelBale() {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            this.$Modal.confirm({
                title: "取消打包", content: "确认批量将订单取消打包？", onOk: async () => {
                    var ids = [];
                    for (var i = 0; i < selection.length; i++) {
                        ids.push(selection[i].id);
                    }
                    await this.$store.dispatch({
                        type: 'backabroadorder/cancleBale',
                        data: { ids: ids }
                    });
                    this.getpage();

                }
            });
        }

        async pendingWarehouse() {
            this.updatePackageStatus(6);
        }
        async updatePackageStatus(statu: number) {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var statuName = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == statu })[0].name;

            this.$Modal.confirm({
                title: "修改包裹状态", content: "确认批量将此订单处理为" + statuName + "？", onOk: async () => {
                    var ids = [];
                    for (var i = 0; i < selection.length; i++) {
                        ids.push(selection[i].id);
                    }
                    await this.$store.dispatch({
                        type: 'backabroadorder/updatePackageStatus',
                        data: { ids: ids, PackageStatus: statu}
                    });
                    this.getpage();

                }
            });
        }
        async arriveWarehouse() {
            this.updatePackageStatus(4);
        }


        async  pdfLinkToBase64(url) {
        try {
            // 使用fetch API获取PDF文件
            const response = await fetch(url);

            // 确保响应成功
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            // 将响应转换为ArrayBuffer
            const arrayBuffer = await response.arrayBuffer();

            // 将ArrayBuffer转换为Base64字符串
            const base64String = this.arrayBufferToBase64(arrayBuffer);

            return base64String;
        } catch (error) {
            console.error('Error fetching the PDF:', error);
            throw error; // 重新抛出错误以便上层调用者可以处理
        }
    }

    // 辅助函数：将ArrayBuffer转换为Base64字符串
     arrayBufferToBase64(buffer) {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

        processPrintList(json) {
            var Options = new Array();
            for (var i in json.val) {
                var option = document.createElement('option');
                option.innerHTML = json.val[i].name;
                option.value = json.val[i].name;
                document.getElementById('SelectPrint').appendChild(option);
            }
            this.isLoadPrintList = true;
            this.$Message.success("已加载打印机，请选择指定打印机");
            return false;
        }



        async printPdf(data) {
            if (!this.isLoadPrintList) {
                var printWorld = new GetPrintWorld(); //new一个打天下对象。不提供URL参数，意为本机的打天下打印服务器（"http://127.0.0.1:8888"）。
                var json = {
                    action: "", refresh: true, defaultprn: true, error: "", val: {}
                };
                json.action = "printers";
                json.refresh = true;                      //为true，则可确保返回刚刚添加的打印机。
                json.defaultprn = true;                   //是否包含缺省打印机信息。
                printWorld.CallbackOnPrinterList(this.processPrintList);
                if (!printWorld.Act(json)) {//数据发送失败
                    alert(printWorld.GetLastError());
                }
                return false;
            }

            var pdfData = {
                pdfGuid: data.pdfGuid,
                userId: data.userId,
                orderNumber: data.orderNumber,
                url: '',
            };
            this.$store.commit('fontmainlandorder/getPdfUrl', pdfData);

            var printSelect: any = document.querySelector('#SelectPrint');
            if (!printSelect.value) {
                this.$Message.success("请选择指定打印机");
                return;
            }
           if (pdfData.url && pdfData.url.length > 0) {
                var printWorld = new GetPrintWorld(); //new 一个打天下对象
               var jsons = { action: "", format: "", content: "", printer: "", cert: "", paperlength: 0, paperwidth: 0 };
               var baseData = await this.pdfLinkToBase64(pdfData.url);
               jsons.action = "printfile";
               jsons.format = "file_base64";
               jsons.content = "data:application/pdf;base64," + baseData;
             //   jsons.format = "pdf_url";        //指定格式为pdf_url。
             //   jsons.content = pdfData.url.replace("https","http");   //pdf文件的url路径
                jsons.paperlength = 15;
               jsons.paperwidth = 10;
               if (this.needCert) {
                   //  jsons.cert = "https://tkyc.ddtmx.com/cer/ddtxianluo.ctf";
                   jsons.cert = "https://tkyc.ddtmx.com/cer/ddtxianluo.ctf";
               }
                jsons.printer = printSelect.value;    //打印机名称，为空或者不指定，则通过缺省打印机打印。
                printWorld.Act(jsons);
               this.toggleButtonState(data, true);
               this.playAudio();
               return true;
            }
        }

        //async arriveWarehouse() {
        //    this.updatePackageStatus(4);
        //}

        async AllarriveWarehouse() {
            var statuName = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == 4 })[0].name;
            this.$Modal.confirm({
                title: "一键送仓", content: "确认批量将包裹状态处理为【" + statuName + "】？", onOk: async () => {
                    await this.$store.dispatch({
                        type: 'backabroadorder/oneClickDelivery',
                        data: {}
                    });
                    this.getpage();
                }
            });
        }

        async getpage() {
            if (this.creationTime.length > 0) {
                this.pagerequest.BeginTime = this.creationTime[0];
            } else {
                this.pagerequest.BeginTime = null;
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.EndTime = this.creationTime[1];
            } else {
                this.pagerequest.EndTime = null;
            }
            if (this.packedTime.length > 0) {
                this.pagerequest.packedBeginTime = this.packedTime[0];
            } else {
                this.pagerequest.packedBeginTime = null;
            }
            if (this.packedTime.length > 1) {
                this.pagerequest.packedEndTime = this.packedTime[1];
            } else {
                this.pagerequest.packedEndTime = null;
            }
            if (this.pagerequest.SearchInfo) {
                this.pagerequest.SearchInfo = this.pagerequest.SearchInfo.trim().toUpperCase();
            }
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            if (!this.clickedButtons) {
                this.clickedButtons = {};
            }
         //   this.clickedButtons = {};
            await this.$store.dispatch({
                type: 'backabroadorder/getAll',
                data: this.pagerequest
            });
            if (this.automatic && this.$store.state.backabroadorder.list && this.$store.state.backabroadorder.list.length == 1) {
                var data = this.$store.state.backabroadorder.list[0];
                try {
                    if (!this.automaticPack) {
                        return;
                    }
                    if (data.logistics.length == 1 && this.selectuser && this.selectuser.id && ((data.packageStatus == 1 && data.orderStatus == 0) && (data.productOrderStatus == null || data.productOrderStatus == 2))) {
                        var sucess = await this.printPdf(data);
                        if (sucess) {

                            await this.$store.dispatch({
                                type: 'backabroadorder/orderBale',
                                data: { id: data.id, SackNums: 0, BaseSkuNums: data.inputBaseSkuNums, packedUserId: this.selectuser.id, warehouseReMark: '' }
                            });
                            var timestamp1 = (new Date()).valueOf().toString();
                            if (this.automaticJump) {
                                this.$router.push({ name: 'intoabroadLogistics', params: { JumpPage: timestamp1 } });
                            }
                        }
                    }

                } finally {
                    this.automatic = false;
                }
            }
        }

        async searchPage() {
            this.$store.state.backabroadorder.currentPage = 1;
            this.getpage();
        }

        get pageSize() {
            return this.$store.state.backabroadorder.pageSize;
        }
        get totalCount() {
            return this.$store.state.backabroadorder.totalCount;
        }
        get currentPage() {
            return this.$store.state.backabroadorder.currentPage;
        }
        async operationData(name: any, data: any) {
            if (name == "复制订单编号") {
                this.copyInfo(data.orderNumber);
            }
            else if (name == "复制快递单号") {
                var stringList: Array<string> = [];
                data.logistics.forEach(function (element) {
                    stringList.push(element.shipment);
                });
                this.copyInfo(stringList.join("/"));
            }
            else if (name == '标记为异常') {
                var updateData = new UpdatebackabroadorderStatu();
                updateData.id = data.id;
                updateData.orderStatus = -1;
                updateData.reMark = data.warehouseNote;
                updateData.orderNumber = data.orderNumber;
                this.$store.state.backabroadorder.updateOrdeData = updateData;
                this.updateOderStatuShow = true;
            } else if (name == '标记为正常') {
                var updateData = new UpdatebackabroadorderStatu();
                updateData.id = data.id;
                updateData.orderStatus = 0;
                updateData.reMark = data.warehouseNote;
                updateData.orderNumber = data.orderNumber;
                updateData.abnormalImageUploadGuid = data.abnormalImageUploadGuid,
                    this.$store.state.backabroadorder.updateOrdeData = updateData;
                this.updateOderStatuShow = true;
            }
            else if (name == '撤销订单') {
                await this.$store.dispatch({
                    type: 'backabroadorder/cancleOrder',
                    data: { orderId: data.id }
                });
                this.getpage();
            }
        }

        copyInfo(data) {
            var _this = this;
            this.$copyText(data).then(function (e) {
                _this.$Message.success("复制成功");
            }, function (e) {
                _this.$Message.error("复制失败");
            });
        }
        toggleButtonState(data, isClicked) {
            this.$set(data, 'printClicked', true); 
        }

        columns = [
            {
                type: 'selection',
                width: 60,
                align: 'center',

            },
            {
                title: '用户编号',
                key: 'userCode',
                width: 90,
            },
            {
                title: '订单状态',
                width: 120,
                key: 'orderStatus',
                render: (h: any, params: any) => {
                    var warehouseNote = params.row.warehouseNote;
                    if (warehouseNote) {
                        warehouseNote = "(" + warehouseNote + ")";
                    }
                    else {
                        warehouseNote = "";
                    }
                    return h('div', [h('p', Enums.WarehouseOrderDisplayStatus.filter(function (item) { return item.value == params.row.orderStatus })[0].name), [h('p', { style: { color: 'red' } }, warehouseNote)]]
                    )
                }
            }, {
                title: '订单编号',
                key: 'orderNumber',
                width: 180,
            },

            {
                title: '快递单号',
                key: 'logistics',
                width: 180,
                render: (h: any, params: any) => {
                    return h('ul', params.row.logistics.map(item => {
                        var productOrderStatusName = "";
                        if (params.row.productOrderStatus != null) {
                            productOrderStatusName = Enums.ProductOrderStatus.filter(function (dataItem) { return dataItem.value == params.row.productOrderStatus })[0].name;
                        }
                        var packagestus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name;
                        var PackageStatus = Enums.ShipmentReceiveStatus.filter(function (dataItem) { return dataItem.value == item.receiveStatus })[0];
                        var shipment = '';
                        var shelfNumber = '';
                        var color = PackageStatus.color;
                        if (item.isReject || item.isReturn || productOrderStatusName == "已取消" || packagestus == "已撤销") {
                            color = "#ff0000";
                        }
                        var count = '';
                        if (item.shipment) {
                            shipment = item.shipment;
                        }
                        if (item.orderCount > 1) {
                            count = "【" + item.orderCount + "】";
                            //shipment = item.shipment + "【" + item.orderCount + "】";
                        }
                        if (item.shelfNumber) {
                            shelfNumber = item.shelfNumber + "";
                            //shipment = shipment + "-" + item.shelfNumber;
                        }
                        return h('li', {
                            domProps: {
                                innerHTML: '<a title="' + PackageStatus.name + '" href="#" style="' + ((color && color.length) > 0 ? "border-left:5px solid " + color + ";padding-left:5px" : "") + '">' + shipment + '<span style="color:red;">' + count + '</span></a>' + (shelfNumber && shelfNumber.length > 0 ? ("<br><span>" + shelfNumber + "</span>") : "")
                            }
                        });
                    }));
                }
            },

            {
                title: '产品订单状态',
                width: 80,
                key: 'productOrderStatus',
                render: (h: any, params: any) => {
                    var color = 'red';
                    if (params.row.productOrderStatus == 3 || params.row.productOrderStatus == 4) {
                        color = 'green';
                    }
                    if (params.row.productOrderStatus != 2) {
                        return h('div', [h('p', { style: { color: color } }, Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name)])
                    }
                    else {
                        return h('span', Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name,
                        )
                    }

                }
            },

            {
                title: '商品信息',
                width: 280,
                key: 'orderProductInfoList',
                render: (h: any, params: any) => {
                    var _this = this;
                    return h('ul', params.row.orderProductInfoList.map(item => {
                        var img = item.url ? '<img src="' + item.url + '" alt="' + item.productName + '" class="img"  onclick="handleChangeImg()" >' : "";
                        return h('li', {
                        }, [
                            h('img', {
                                attrs: {
                                    class: "img",
                                    src: item.url,
                                    preview: params.row.id,
                                    "preview-text": params.row.orderNumber + "-" + item.productName
                                }
                            }), item.productName, h('font', { style: { color: "red" } }, '*'), h('h2', { style: { color: "red", display: "inline-block" } }, item.count)]);
                    }));
                }
            },
            {
                title: '时间',
                width: 250,
                render: (h: any, params: any) => {
                    return h('div', [h('h3', "创建时间:" + (params.row.createTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.createTime))))
                        , h('h3', "到货时间:" + (params.row.receivedTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.receivedTime))))
                        , h('h3', "更新时间:" + (params.row.updateTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.updateTime))))
                        , h('h3', "打包时间:" + (params.row.packedTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.packedTime))))
                        , h('h3', "送仓时间:" + (params.row.arriveWarehouseTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.arriveWarehouseTime))))
                    ])
                }
            },
            {
                title: '仓储名称',
                key: 'storeName',
                width: 150,
            },



            {
                title: '费用',
                width: 200,
                render: (h: any, params: any) => {
                    var a = "";
                    var b = "";
                    var c = "";
                    var d = "";
                    var e = "";
                    var f = "";
                    if (params.row.isPay) {
                        a = 'red';
                    }
                    else {
                        a = 'dark';
                    }
                    if (params.row.freightCost) {
                        b = 'red';
                    }
                    else {
                        b = 'dark';
                    }
                    if (params.row.extraCost) {
                        c = 'red';
                    }
                    else {
                        c = 'dark';
                    }
                    if (params.row.extraCostDescribe) {
                        d = 'red';
                    }
                    else {
                        d = 'dark';
                    }
                    if (params.row.sackTotalAmount > 0) {
                        e = 'red';
                    }
                    else {
                        e = 'dark';
                    }
                    if (params.row.skuTotalAmount > 0) {
                        f = 'red';
                    }
                    else {
                        f = 'dark';
                    }
                    return h('div', [h('h3', { style: { color: a } }, "是否支付:" + (params.row.isPay ? this.L('是') : this.L('否'))), h('h3', { style: { color: e } }, "打包袋金额:" + (params.row.sackTotalAmount == null ? "" : params.row.sackTotalAmount)), h('h3', { style: { color: f } }, "SKU金额:" + (params.row.skuTotalAmount == null ? "" : params.row.skuTotalAmount))])
                }
            },
            {
                title: '单号信息',
                width: 220,
                render: (h: any, params: any) => {
                    return h('div', [
                        h('h3', "退单编号：" + (params.row.returnNumber || "")),
                        h('h3', "物流单号：" + (params.row.tradeNo || ""))
                    ])
                }
            },
            {
                title: '包裹状态',
                width: 90,
                key: 'packageStatus',
                render: (h: any, params: any) => {

                    var color = 'black';
                    if (params.row.packageStatus == 2 || params.row.packageStatus == 4) {
                        color = 'green';
                    }

                    return h('div', [h('p', { style: { color: color } }, Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name)])
                //    return h('span', Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name);
                }
            },
            {
                title: '打包人',
                width: 150,
                key: 'packedUserName',
            },
            {
                title: '备注',
                width: 180,
                key: 'reMark',
                render: (h: any, params: any) => {
                    return h('div', [h('span', { style: { color: 'red' } }, params.row.reMark)]
                    )
                }
            },
            {
                title: '采购订单编号',
                key: 'logistics',
                width: 150,
                render: (h: any, params: any) => {
                    return h('ul', params.row.logistics.map(item => {
                        return h('li', {
                            domProps: {
                                innerHTML: '<span> ' + (item.purchaseOrderNumber ? item.purchaseOrderNumber : "") + ' </span>'
                            }
                        });
                    }));
                }
            },
            {
                title: '异常图片',
                key: 'abnormalImageUploadGuid',
                width: 95,
                render: (h: any, params: any) => {
                    if (params.row.abnormalImageUploadGuid) {
                        var data = { imageGuid: params.row.abnormalImageUploadGuid, url: null };
                        this.$store.commit('expressuserinfo/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: "yc_" + params.row.id,
                                "preview-text": params.row.orderNumber + "异常图片"
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },
            {
                title: '打包袋数量',
                key: 'sackNums',
                width: 80,
            },
            {
                title: '基本SKU数量',
                key: 'baseSkuNums',
                width: 80,
            },

            {
                title: '操作',
                width: 100,
                fixed: 'left',
                key: 'id',
                render: (h: any, params: any) => {

                    var data = params.row;
                    var rowId = data.id;
                    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                    var productOrderStatusName = "";
                    if (data.productOrderStatus != null) {
                        productOrderStatusName = Enums.ProductOrderStatus.filter(function (item) { return item.value == data.productOrderStatus })[0].name;
                    }
                    var orderStatus = Enums.WarehouseOrderStatus.filter(function (item) { return item.value == data.orderStatus })[0].name;
                    var _this = this;
                    var menu = [];
                    //if (params.row.pdfGuid && params.row.pdfGuid.length > 1) {
                    //    menu.push("查看Pdf");
                    //}
                    if (params.row.orderStatus == 0 && params.row.packageStatus != 5) {
                        menu.push("标记为异常");
                    }
                    if (params.row.orderStatus == -1 && params.row.packageStatus != 5) {
                        menu.push("标记为正常");
                    }
                    if (params.row.orderStatus == -1) {
                        menu.push("撤销订单");
                    }
                    menu.push("复制订单编号");
                    if (params.row.logistics && params.row.logistics.length > 0) {
                        menu.push("复制快递单号");
                    }
                    return h('div', [
                        h('Dropdown', {
                            props: {
                                transfer: true,
                                trigger: 'click',
                            },
                            on: {
                                'on-click': (name) => {
                                    _this.operationData(name, params.row);
                                }
                            }

                        }, [
                            h('Button',
                                {
                                    domProps: {
                                        innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                                    },
                                    props: {
                                        type: 'primary',
                                    }

                                }),

                            h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                                return h('DropdownItem', { props: { name: item } }, item)
                            })
                            )],
                        ),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '68px',
                                backgroundColor: params.row.printClicked ? 'green' : '',
                            },
                            attrs: {
                                id: 'printPdf' + rowId // Dynamic ID based on row.id
                            },
                            on: {
                                click: () => {
                                    var data = params.row;
                                    var _this = this;
                                    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                                    if (packageStatus != "已收货") {
                                        this.$Modal.confirm({
                                            title: "打印PDF", content: "此订单包裹为【" + packageStatus + "】状态，不是【已收货】，是否打印此订单的面单？", onOk: async () => {
                                                _this.printPdf(data);
                                            }
                                        });
                                    }
                                    else {
                                        _this.printPdf(data);
                                    }
                                }
                            }
                        }, "打印PDF"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '68px',
                            },
                            on: {
                                click: () => {
                                    var data = params.row;
                                    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                                    if (packageStatus != "已收货") {
                                        this.$Modal.confirm({
                                            title: "查看PDF", content: "此订单包裹为【" + packageStatus + "】状态，不是【已收货】，是否查看此订单的面单？", onOk: async () => {
                                                this.$store.commit('fontorder/getPdf', {
                                                    pdfGuid: data.pdfGuid,
                                                    userId: data.userId,
                                                    orderNumber: data.orderNumber
                                                });
                                            }
                                        });
                                    }
                                    else {
                                        this.$store.commit('fontorder/getPdf', {
                                            pdfGuid: data.pdfGuid,
                                            userId: data.userId,
                                            orderNumber: data.orderNumber
                                        });
                                    }
                                }
                            }

                        }, "查看PDF"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '68px',
                                height: '30px',
                                display: (packageStatus == "未收货" || packageStatus == "已收货" && orderStatus == "正常") && productOrderStatusName != "已取消" ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {
                                    this.Newpacked(data);
                                }
                            }

                        }, "打包")
                    ]);
                }
            }
        ]


        async getUserList() {
            this.user = await this.$store.dispatch({
                type: 'user/getUserList',
                data: {}
            });
            if (this.user.length > 0) {
                var data = this.user.filter(function (item) { return item.id == abp.session.userId });
                if (data.length > 0) {
                    this.selectuser.id = data[0].id;
                }
            }
        }

        async created() {
            this.getUserList();
            this.getData();
            this.getpage();

        }
        async mounted() {
        }
    }
